import React from "react";
import { Cell, Pie, PieChart } from "recharts";

import {
	GraphBodySC,
	GraphCardSC,
	GraphInnerContainerSC,
	GraphLegendItemSC,
	GraphLegendLabelSC,
	GraphLegendSC,
	GraphLegendSubtitleSC,
	GraphLegendTitleSC,
	GraphPieSC,
	GraphTitleSC
} from "./styles";

export const Donut = ({
	data,
	title,
	subtitle,
	total,
	width = 120,
	height = 120
}) => {
	const COLORS = [
		"#FF0000",
		"#0000FD",
		"#28a745",
		"#FF7F01",
		"#7F00FE",
		"#CECE00",
		"#FF33FD",
		"#33FFFF",
		"#33FF9A",
		"#6c757d",
		"#FF3333",
		"#CD6600",
		"#FFFF02",
		"#3131FF",
		"#0080FE",
		"#3299FF",
		"#9932FF",
		"#FF00FD",
		"#FF3398",
		"#FF007E",
		"#00FFFF",
		"#00FF02",
		"#33FF35",
		"#67CD00",
		"#80FF01",
		"#00FF81"
	];

	return (
		<GraphCardSC>
			<GraphInnerContainerSC>
				<GraphTitleSC>
					<strong>{title}</strong>
					{subtitle && <span> - {subtitle}</span>}
				</GraphTitleSC>

				<GraphBodySC>
					<GraphPieSC>
						<PieChart width={width} height={height}>
							<Pie
								data={data}
								innerRadius={width * 0.25}
								outerRadius={width * 0.4}
								fill="#8884d8"
								paddingAngle={data.length}
								dataKey="value"
							>
								{data.map((entry, index) => (
									<Cell
										key={`cell-${index}`}
										fill={entry.color || COLORS[index % COLORS.length]}
									/>
								))}
							</Pie>
						</PieChart>
					</GraphPieSC>

					<GraphLegendSC>
						<GraphLegendTitleSC>{total} - Total</GraphLegendTitleSC>
						{data.map((entry, index) => (
							<GraphLegendItemSC key={`cell-${index}`}>
								<GraphLegendLabelSC
									color={entry.color || COLORS[index % COLORS.length]}
								/>

								<GraphLegendTitleSC>{entry.title}</GraphLegendTitleSC>
								{entry.subtitle && (
									<>
										<GraphLegendSubtitleSC> - </GraphLegendSubtitleSC>
										<GraphLegendSubtitleSC>
											{entry.subtitle}
										</GraphLegendSubtitleSC>
									</>
								)}
							</GraphLegendItemSC>
						))}
					</GraphLegendSC>
				</GraphBodySC>
			</GraphInnerContainerSC>
		</GraphCardSC>
	);
};
